import { Subject } from '@casl/ability/dist/types/types';
import Jumbotron from '@src/@core/layouts/components/jumbotron';
import HomeNavbar from '@src/@core/layouts/components/navbar/HomeNavbar';
import React, { lazy } from 'react';

// ** Document title
const TemplateTitle = '%s - SPACCURATE';

export type RoutesType = {
  path: string;
  component: React.LazyExoticComponent<(props: any) => JSX.Element>;
  layout?: {
    name: string;
    jumbotron?: JSX.Element;
  };
  className?: string;
  exact?: boolean;
  meta?: {
    publicRoute?: boolean;
    authRoute?: boolean;
    action?: string;
    resource?: Subject;
  };
};

// ** Merge Routes
// Note: routes should go from most complex to most basic ('/' should come last)
//    also consider the order Router.tsx maps routes (Horizontal -> Vertical -> Blank)
//    you want Blank layout + '/' to come last
const Routes: RoutesType[] = [
  {
    path: '/biz/:businessFriendlyId',
    component: lazy(() => import('../../features/business')),
    meta: {
      publicRoute: true,
    },
  },
  {
    path: '/pricing/:businessAndLocationFriendlyId',
    component: lazy(() => import('../../features/pricing')),
    meta: {
      publicRoute: true,
    },
  },
  {
    path: '/book',
    component: lazy(() => import('../../features/booking')),
    meta: {
      publicRoute: true,
    },
  },
  {
    path: '/payment',
    component: lazy(() => import('../../features/payment')),
    meta: {
      publicRoute: true,
    },
  },
  {
    path: '/booking-confirmation/:appointmentId',
    component: lazy(() => import('../../features/booking-confirmation')),
    meta: {
      publicRoute: true,
    },
  },
  {
    path: '/account-settings',
    component: lazy(() => import('../../features/account-settings')),
    meta: {
      publicRoute: false,
    },
  },
  {
    path: '/appointment/:appointmentId/overview',
    component: lazy(() => import('../../features/appointment-tip')),
    meta: {
      publicRoute: true,
    },
  },
  {
    path: '/appointments',
    component: lazy(() => import('../../features/appointments')),
    meta: {
      publicRoute: false,
    },
  },
  {
    path: '/gift-card/purchase/payment',
    component: lazy(() => import('../../features/gift-card-purchase/payment')),
    meta: {
      publicRoute: false,
    },
  },
  {
    path: '/gift-card/purchase/cart',
    component: lazy(
      () => import('../../features/gift-card-purchase/shopping-cart')
    ),
    meta: {
      publicRoute: false,
    },
  },
  {
    path: '/gift-card/purchase',
    component: lazy(() => import('../../features/gift-card-purchase')),
    meta: {
      publicRoute: false,
    },
  },
  {
    path: '/gift-card/balance',
    component: lazy(() => import('../../features/gift-card/balance')),
    meta: {
      publicRoute: true,
    },
  },
  {
    path: '/gift-card',
    component: lazy(() => import('../../features/gift-card')),
    meta: {
      publicRoute: true,
    },
  },
  // {
  //   path: '/schedule',
  //   component: lazy(() => import('../../features/therapist-schedule')),
  //   meta: {
  //     publicRoute: false,
  //     action: 'read',
  //     resource: 'schedule',
  //   },
  // },
  {
    path: '/oidc-callback',
    component: lazy(() => import('../../features/authentication/OidcCallback')),
    meta: {
      authRoute: true,
    },
  },
  {
    path: '/login/:email?/:confirmationCode?',
    component: lazy(() => import('../../features/authentication/login')),
    layout: {
      name: 'BlankLayout',
    },
    meta: {
      publicRoute: true,
    },
  },
  {
    path: '/register',
    component: lazy(() => import('../../features/authentication/register')),
    layout: {
      name: 'BlankLayout',
    },
    meta: {
      publicRoute: true,
    },
  },
  {
    path: '/forgot-password',
    component: lazy(
      () => import('../../features/authentication/forgot-password')
    ),
    layout: {
      name: 'BlankLayout',
    },
    meta: {
      publicRoute: true,
    },
  },
  {
    path: '/error',
    component: lazy(() => import('../../features/error')),
  },
  {
    path: '/session-expired',
    component: lazy(() => import('../../features/error/session-expired')),
    layout: {
      name: 'BlankLayout',
    },
    meta: {
      publicRoute: true,
    },
  },
  {
    path: '/',
    component: lazy(() => import('../../features/locations')),
    meta: {
      publicRoute: true,
    },
    layout: {
      name: 'BlankLayout',
      jumbotron: <Jumbotron navbar={<HomeNavbar />} />,
    },
  },
];

export { TemplateTitle, Routes };
